import type { JSX } from "react";

/**
 * The post's own footer, at page scale.
 *
 * The account it links is the surface's own: the home directory, and a city with
 * no handle of its own, point at the master account, while a city guide points at
 * the handle that city posts as. A guide payload with no handle therefore keeps
 * the master identity rather than printing a link to nowhere — the same
 * fallback the guide's closing CTA makes.
 */
export function Footer({
  instagramHref = "https://instagram.com/noko.city",
  instagramLabel = "@NOKO.CITY",
}: {
  instagramHref?: string;
  instagramLabel?: string;
} = {}): JSX.Element {
  return (
    <footer className="pb-10 pt-[8vh]">
      <div className="mx-auto w-full max-w-[1080px] px-[6%]">
        <div className="h-1 w-full bg-white/70" />
        <div className="flex flex-wrap items-baseline justify-between gap-4 pt-6 font-mono text-[clamp(0.65rem,1.5vw,1rem)] font-semibold tracking-wider text-paper-header">
          <span>CITY EVENT GUIDE</span>
          <a
            href={instagramHref}
            target="_blank"
            rel="noreferrer"
            className="text-paper-muted transition-colors hover:text-accent"
          >
            {instagramLabel}
          </a>
        </div>
        <p className="pt-8 font-mono text-[0.65rem] font-semibold tracking-wider text-paper-muted/60">
          WHERE ARE WE TODAY? · NOKO.CITY
        </p>
      </div>
    </footer>
  );
}
